import React from 'react'

function Scroll() {
    return (
        <div className='scroll_one'>
            <marquee>വിൽവട്ടം സർവീസ് സഹകരണ ബാങ്ക് ക്ലിപ്തം നമ്പർ-337, കുറിച്ചിക്കര, തൃശ്ശൂർ - 28 Ph 2695623, 2694717. =======================

ചേറൂര് 2332126 ,കുറ്റുമുക്ക്: 2320111 ,പുത്തൻ വെട്ടുവഴി: 232 1632 ,താണിക്കുടം 2695523 </marquee>
        </div>
    )
}

export default Scroll